import { FormAnswers } from '../../../types';
import { Question } from './types';

export const getDefaultValue = (item: Question, formsAnswers: FormAnswers[], allQuestions: Question[]) => {
  const { formId, question, PetRecordId, defaultAnswer } = item;
  const { id } = question;
  const AnswerOptions = allQuestions.find(q => q.question.id === id)?.question.AnswerOptions;
  const hasAnswerOptions = !!AnswerOptions?.length;
  const formAnswer = formsAnswers.find(answer => answer.questionId === id && answer.formId === formId)?.answers.find(answer => answer.PetRecordId === PetRecordId);

  if (question.get_answers_from && (question.type === 'DROPDOWN' || question.type === 'RADIO')) {
    const answerValue = formAnswer?.answer;
    const defaultValue = answerValue || defaultAnswer;
    return [defaultValue];
  }

  const answerValue = hasAnswerOptions ? formAnswer?.AnswerOptionId : formAnswer?.answer;
  const defaultValue = answerValue || defaultAnswer;

  return defaultValue;
};
